import React, { useRef } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { lookInsideSlides } from "../../data/content";
import { OFFER_HASH } from "../../data/links";
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector("a");
    const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({
      left: dir * step,
      behavior: "smooth"
    });
  };
  return <section className="w-full bg-teal-light px-5 py-14 md:py-20" data-id="element-163" data-mp="3iiuddajolb7s">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="3drcdyqxb3iox">
        <SectionHeading eyebrow="Look inside" title="Discover what’s inside Prenatal Training Pro 2026" subtitle="Explore structured weekly workouts, exercise tables, sets, reps, rest periods, RPE targets, regressions, progressions, modifications, home alternatives, gym alternatives and professional coaching resources." data-id="element-165" data-mp="3dpj658ayisfc" />

        <div ref={trackRef} className="no-scrollbar mt-8 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2" data-id="element-166" data-mp="kpjbyon07hg9">
          {lookInsideSlides.map(slide => <a key={slide.caption} href={OFFER_HASH} className="group w-[60%] shrink-0 snap-start overflow-hidden rounded-xl bg-white shadow-[0_8px_20px_-14px_rgba(28,47,79,0.45)] sm:w-[32%] lg:w-[23.5%]" data-id="element-167" data-mp="pivz0uc1bg6w">
              <div className="overflow-hidden" data-id="element-168" data-mp="3szuqvqlpw8vx">
                <img src={slide.image} alt={`Inside page preview: ${slide.caption}`} className="aspect-[3/4] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-169" data-mp="1s9rd45xzxxf" />
              </div>
              <p className="border-t-4 border-gold px-3 py-2.5 font-display text-xs font-extrabold uppercase leading-snug text-navy" data-id="element-170" data-mp="atgbdn7svqvf">{slide.caption}</p>
            </a>)}
        </div>

        <div className="mt-5 flex justify-center gap-2" data-id="element-171" data-mp="1m5qzvhfih0u2">
          {([-1, 1] as const).map(dir => <button key={dir} type="button" onClick={() => scroll(dir)} aria-label={dir === -1 ? "Previous pages" : "Next pages"} className="flex h-10 w-10 items-center justify-center rounded-full bg-teal text-white transition-colors duration-150 hover:bg-navy focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-navy/30" data-id="element-172" data-mp="3j64wuck56pdh">
              {dir === -1 ? <ChevronLeftIcon className="h-4 w-4" data-id="element-173" data-mp="2vi3slftzxv3v" /> : <ChevronRightIcon className="h-4 w-4" data-id="element-174" data-mp="2vj557oqnupnp" />}
            </button>)}
        </div>
      </div>
    </section>;
}